export enum TableElementStatus {
  DANGER = 'danger',
  WARN = 'warning',
  SUCCESS = 'success',
  NONE = ''
}
